import { render, staticRenderFns } from "./F8.vue?vue&type=template&id=6391c6f1&scoped=true"
import script from "./F8.vue?vue&type=script&lang=js"
export * from "./F8.vue?vue&type=script&lang=js"
import style0 from "./F8.vue?vue&type=style&index=0&id=6391c6f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6391c6f1",
  null
  
)

export default component.exports